export enum ERROR_KEYS {
  REQUIRED = 'required',
  HEX_COLOR = 'hexColor',
  JSON_SCHEMA = 'jsonSchema',
  JSON_PARSE = 'jsonParseError',
  JSON_TYPE = 'jsonInvalidType',
  TEMPLATE_NAME = 'templateName',
  SAME_PASSWORDS = 'samePasswords',
  URL_FRIENDLY_SLUG = 'urlFriendlySlug',
  MAX_LENGTH = 'maxlength'
};

export const ERROR_MESSAGES: Record<ERROR_KEYS, string> = {
  [ERROR_KEYS.REQUIRED]: 'This field is required',
  [ERROR_KEYS.HEX_COLOR]: 'Invalid hex color format',
  [ERROR_KEYS.JSON_SCHEMA]: 'Invalid JSON schema',
  [ERROR_KEYS.JSON_PARSE]: 'Error parsing JSON file',
  [ERROR_KEYS.JSON_TYPE]: 'Invalid file type',
  [ERROR_KEYS.TEMPLATE_NAME]: 'Template name already exists',
  [ERROR_KEYS.SAME_PASSWORDS]: 'Passwords do not match',
  [ERROR_KEYS.URL_FRIENDLY_SLUG]: 'Only A-Z, a-z, numbers and hyphens are allowed',
  [ERROR_KEYS.MAX_LENGTH]: 'Text is too long'
};
